import { convertToFahrenheit, convertToInches } from './convertUnits';
import { prepareNumber } from './prepareNumber';
//const intl = useIntl();

const unitMessages: any = {
    'perc': ['%', 0],
    'hrs': ['hours', 0],
    'day': ['days', 0]
    //'hrs': [intl.formatMessage({ id: 'common.units.hours' }),1],
    //'day': [intl.formatMessage({ id: 'common.units.days' }),1]
}

export default ({ text, units, noNbsp }: { text: string, units: string, noNbsp?: boolean }) => {
    let splitted = text.split('@@');
    let final = '';
    const space = noNbsp ? ' ' : '\u00A0'
    for (let part of splitted) {
        let detailSplitted = part.split('#');
        if (detailSplitted.length < 2) {
            final += part;
            continue;
        }
        let [textVal, unit, precision] = detailSplitted;
        let val = parseFloat(textVal);
        if (unitMessages[unit]) {
            let [unitText, fixed] = unitMessages[unit];
            fixed = precision ?? fixed;
            final += `${prepareNumber(val, fixed)}${space}${unitText}`;
            continue;
        }

        if (unit === 'deg') {
            let valCelsius = `${prepareNumber(val, 1)}${space}°C`;
            let valFahrenheit = `${prepareNumber(convertToFahrenheit(val), 1)}${space}°F`;
            final += units == 'C' ? `${valCelsius}${space}(${valFahrenheit})` : `${valFahrenheit}${space}(${valCelsius})`;
        }
        else if (unit === 'mm') {
            let valMm = `${prepareNumber(val, 0)}${space}mm`;
            let valInches = `${prepareNumber(convertToInches(val), 2)}${space}in`;
            final += units == 'C' ? `${valMm}${space}(${valInches})` : `${valInches}${space}(${valMm})`;
        }
        else if (unit === 'nounit' || unit === 'wi' || !unitMessages[unit]) {
            final += prepareNumber(val, 1)
        }
    }
    return final;
}